'use client';

import React from 'react';
import clsx from 'clsx';

type SearchItemProps = {
  onSelect: () => void;
  children: React.ReactNode;
};
export function SearchItem({ children, onSelect }: SearchItemProps) {
  return (
    <li className="rounded-sm aria-selected:bg-secondary-hover aria-selected:text-primary data-disabled:pointer-events-none data-disabled:opacity-50 hover:bg-secondary-hover">
      <button
        className={clsx(
          'relative w-full cursor-default select-none px-2.5 py-3 text-sm font-semibold outline-hidden',
          'grid grid-flow-col grid-rows-2 place-content-between gap-x-4 gap-y-1',
        )}
        onClick={onSelect}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onSelect();
          }
        }}
        type="button"
      >
        {children}
      </button>
    </li>
  );
}
